import { h, Component } from 'preact';

import style from '../../style/modal.sass';

export default class Modal extends Component {
  render(props) {
    const ModalComponentType = props.modalComponentType;
    return (
      <div id="form-modal" className={style.modal} style={{
        visibility: props.doShowModal?'visible':'hidden',
        height: props.modalOverlayHeight+'px'
      }}>
        <div className={style['window-'+props.brand]}>
          <div className={style.component}>
            <ModalComponentType {...props} />
          </div>
        </div>
      </div>
    );
  }
}
